<template>
  <documents :driver-data="driverData" />
</template>

<script>
import { provide, ref } from '@vue/composition-api'
import Documents from '@/views/driver/documents/Documents.vue'

export default {
  components: { Documents },
  props: {
    driverData: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const cardViewMode = ref(false)
    provide('cardViewMode', cardViewMode)
  },
}
</script>

<style scoped>

</style>
